import { FileTypeEnum } from '../../enums/FileTypeEnum';

export type OfficeRouteSegment = 'document' | 'spreadsheet' | 'presentation' | 'wopitest';

/** Legacy SPA segments → canonical. Kept for redirects while old bookmarks bounce. */
export const LEGACY_OFFICE_REDIRECTS = {
  word: 'document',
  excel: 'spreadsheet',
  powerpoint: 'presentation',
} as const satisfies Record<string, OfficeRouteSegment>;

export type LegacyOfficeSegment = keyof typeof LEGACY_OFFICE_REDIRECTS;

const OFFICE_EDITABLE_TYPES = new Set<FileTypeEnum>([
  FileTypeEnum.Word,
  FileTypeEnum.Excel,
  FileTypeEnum.Powerpoint,
  FileTypeEnum.Wopitest,
]);

/** Word / Excel / PowerPoint / Wopitest — same set as classic Office routes. */
export function isOfficeEditableType(fileType: FileTypeEnum | null | undefined): boolean {
  return fileType != null && OFFICE_EDITABLE_TYPES.has(fileType);
}

export function getOfficeRouteSegment(fileType: FileTypeEnum): OfficeRouteSegment {
  switch (fileType) {
    case FileTypeEnum.Word:
      return 'document';
    case FileTypeEnum.Excel:
      return 'spreadsheet';
    case FileTypeEnum.Powerpoint:
      return 'presentation';
    case FileTypeEnum.Wopitest:
      return 'wopitest';
    default:
      // ponytail: callers only pass office types; ceiling = wrong URL for non-office
      return 'document';
  }
}

/** Build canonical office SPA path, e.g. `/document/123?r=0`. */
export function getOfficePath(
  fileId: string | number,
  fileType: FileTypeEnum,
  search?: string,
): string {
  const segment = getOfficeRouteSegment(fileType);
  if (!search) return `/${segment}/${fileId}`;
  const qs = search.startsWith('?') ? search : `?${search}`;
  return `/${segment}/${fileId}${qs}`;
}
